<template>
  <div>
    <!-- Data Stores Hack, need to be loaded first -->
    <!-- <POSStore ref="posStore"/> -->
    <ShiftStore ref="shiftStore"/>
    <!-- <POSStore ref="posStore"/> -->
    <!-- ///////////////////////////////////////// -->

    <h1>Cashiers Report</h1>
    <!-- <p>ℹ️ Info: This report summarizes the transactional data from Moneris.</p> -->
    
    <GenericDatePeriodSelector storeName="shiftStore" dateKey="week" />
    <GenericDaysSelector storeName="shiftStore" />
    <!-- <ReconcilliationViewSelector storeName="shiftStore" /> -->
    
    <ExportToExcel 
      :tables="['RCGB_Days', 'RCGB_Cashiers', 'RMGB_Days', 'RMGB_Cashiers', 'WGB_Days', 'WGB_Cashiers']" 
      bookName="Cashiers Report"
      storeName="shiftStore"
    />

    <div class="dont-print">
      <br>
      <br>
      Subtract {{ls.startBuffer}} minutes from Shift Start :<input type="text" v-model="ls.startBuffer">
      Add {{ls.endBuffer}} minutes from Shift End :<input type="text" v-model="ls.endBuffer">
      <br>
      <input type="search" placeholder="Filter the Cashiers..." v-model="filter">  
    </div>
    
    
    <div v-for="location in $locations" :key="location">
      <CashiersTable 
        storeName="shiftStore" 
        :location="location" 
        :filter="filter" 
        :startBuffer="ls.startBuffer"
        :endBuffer="ls.endBuffer"
      />
      <div class="pagebreak"> </div>
    </div>
    
    
  </div>
</template>

<script>
// import POSStore from '@/pages/Reports/POS/Stores/POSStore.vue'
import ShiftStore from '@/pages/Reports/Shifts/Stores/ShiftStore.vue'
import CashiersTable from '@/pages/Reports/Cashiers/Components/CashiersTable.vue'
import localstorageMixin from '@/mixins/localstorageMixin.js'


export default {
  name: 'CashiersReport',
  mixins : [localstorageMixin],
  components:{ 
    CashiersTable, 
    ShiftStore, 
  },
  data(){
    return {
      filter: "",
      ls:{
        startBuffer:"15",
        endBuffer:"15"
      },
    }
  },
  provide(){
    return {
      page: this,
    }
  },
  computed:{
    timestamps(){return this.$refs.shiftStore.timestamps},
  },
  methods:{
  }
}
</script>

<style scoped>

</style>